import { Breadcrumb, Container } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";

const NFeCadastroView = () => {
  const { pathname } = useLocation();

  const steps = [
    { label: "Operação", path: `/fiscal/nfe/cadastro/operacao` },
    { label: "Finalidade", path: `/fiscal/nfe/cadastro/finalidade` },
    { label: "Referência", path: `/fiscal/nfe/cadastro/referencia` },
    { label: "Tributação", path: `/fiscal/nfe/cadastro/tributacao` },
    { label: "Destinatario", path: `/fiscal/nfe/cadastro/destinatario` },
    { label: "Consumidor Final", path: `/fiscal/nfe/cadastro/consumidorfinal` },
    { label: "Destino Operação", path: `/fiscal/nfe/cadastro/destinooperacao` },
    { label: "Item", path: `/fiscal/nfe/cadastro/item` },
    { label: "Pagamento", path: `/fiscal/nfe/cadastro/pagamento` },
    { label: "Modalidade Frete", path: `/fiscal/nfe/cadastro/modalidadefrete` },
    { label: "Transporte", path: `/fiscal/nfe/cadastro/transporte` },
    { label: "Volumes", path: `/fiscal/nfe/cadastro/volumes` },
    {
      label: "Informações Adicionais",
      path: `/fiscal/nfe/cadastro/informacoesadicionais`,
    },
  ];
  const currentIndex = steps.findIndex((s) => pathname.startsWith(s.path));
  const visibleSteps = steps.slice(0, currentIndex + 1);
  const ellipsisIndex = { label: "...", path: "ellipsis" };
  const showSteps =
    visibleSteps.length > 3
      ? [ellipsisIndex, ...visibleSteps.slice(-3)]
      : visibleSteps;

  return (
    <Container>
      <Breadcrumb className="mt-3">
        {showSteps.map((step, index) => {
          const isComplete = visibleSteps.indexOf(step) < currentIndex;

          if (step.path === "ellipsis") {
            return (
              <Breadcrumb.Item
                linkAs="span"
                key="ellipsis"
                active={false}
                className={isComplete ? "text-success" : ""}
              >
                ...
              </Breadcrumb.Item>
            );
          }

          const isActive = pathname === step.path;

          return (
            <Breadcrumb.Item
              key={step.path}
              linkAs="span"
              linkProps={isActive ? {} : { href: step.path }}
              active={isActive}
              className={isComplete ? "text-success" : ""}
            >
              {step.label}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
      <Outlet />
    </Container>
  );
};

export default NFeCadastroView;
